import { render } from "./AktuelleFejl.vue?vue&type=template&id=4ef72a00&scoped=true"
import script from "./AktuelleFejl.vue?vue&type=script&lang=js"
export * from "./AktuelleFejl.vue?vue&type=script&lang=js"

import "./AktuelleFejl.vue?vue&type=style&index=0&id=4ef72a00&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef72a00"]])

export default __exports__